import setCurrentPage from "src/Utils/setCurrentPage";
import UseCaseVideoPanel from "src/Components/Common/UseCaseVideoPanel";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_USE_CASE_1 = [
  {
    icon: "arrowsUpWithDollarSign",
    iconColor: "white",
    text: `<b>$200M+</b> saved per \nannum, through \npenalty avoidance`,
    listItemCustomStyle: { width: "248px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "dartboard",
    iconColor: "white",
    text: `Improve efficiency \nby <b>20-30%</b>`,
    listItemCustomStyle: { width: "234px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "arrowsDownWithPeople",
    iconColor: "white",
    text: `Reduce manual \ntouchpoints by <b>80%</b>`,
    listItemCustomStyle: { width: "230px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_EV_DEMO_USE_CASE_1 = {
  headerRightText: "GET THE EDGE",
  headerLeftImage: "EdgeverveLogo.png",
  title: "Order management",
  titleStyle: {
    marginTop: "-32px",
    fontSize: "100px",
    textTransform: "uppercase",
  },
  subtitle: "Use case 1",
  subtitleStyle: { color: "#92D1FF", fontSize: "24px", marginTop: "32px" },
  text: "Amplify customer experiences with our agile, touchless order \nmanagement solution, delivering the edge you need.",
  textStyle: { marginTop: "60px", marginBottom: "40px" },
  listData: LIST_DATA_USE_CASE_1,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(403),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "EV/EV_demo_Intro_04.png",
  rightSideComponent: (
    <UseCaseVideoPanel
      infoIconClick={() => {
        setPreviousPage(404);
        setCurrentPage(419);
      }}
      imageClick={() => setCurrentPage(405)}
      title="WATCH THE EXPLAINER VIDEO"
      image="EV/EV_demo_use_case_01.png"
      bottomButtons={[
        {
          label: "DEMO VIDEO",
          onClick: () => setCurrentPage(406),
          endIcon: "play",
        },
      ]}
    />
  ),
};

export default DATA_EV_DEMO_USE_CASE_1;
